import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lightning, EnvelopeSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-[#050505]" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-10">
          <Lightning size={28} weight="fill" className="text-[#E30613]" />
          <span className="font-display text-2xl uppercase font-black">FitAgenda <span className="text-[#E30613]">CH</span></span>
        </Link>
        <div className="border border-white/10 bg-[#0A0A0A] p-8">
          {sent ? (
            <div className="text-center">
              <EnvelopeSimple size={56} weight="duotone" className="text-[#E30613] mx-auto" />
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold mt-6">{t("auth.forgot_sent_tag")}</div>
              <h1 className="font-display text-2xl uppercase font-black mt-2">{t("auth.forgot_sent_title")}</h1>
              <p className="text-sm text-zinc-300 mt-4 leading-relaxed" data-testid="forgot-sent-msg">{t("auth.forgot_sent_body", { email })}</p>
              <Link to="/login" className="inline-block mt-6 text-xs uppercase tracking-widest text-[#E30613] hover:text-white font-bold">← {t("auth.login_link")}</Link>
            </div>
          ) : (
            <>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold">{t("auth.forgot_tag")}</div>
              <h1 className="font-display text-3xl uppercase font-black mt-2">{t("auth.forgot_title")}</h1>
              <p className="text-sm text-zinc-400 mt-3 leading-relaxed">{t("auth.forgot_subtitle")}</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div className="space-y-2">
                  <Label className="text-xs uppercase tracking-widest font-bold text-zinc-400">{t("auth.email")}</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="bg-black border-white/20 rounded-none h-11 focus-visible:ring-[#E30613] focus-visible:border-[#E30613]" data-testid="forgot-email-input" />
                </div>
                <Button type="submit" disabled={loading}
                  className="w-full bg-[#E30613] hover:bg-[#FF1A27] text-white uppercase tracking-[0.2em] font-bold rounded-none h-12"
                  data-testid="forgot-submit-button">
                  {loading ? t("common.loading") : t("auth.forgot_send")}
                </Button>
              </form>
              <div className="mt-6 text-xs text-zinc-500 text-center">
                <Link to="/login" className="text-[#E30613] hover:text-white font-bold uppercase tracking-wider">← {t("auth.login_link")}</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
